import { render, staticRenderFns } from "./RuleListStart.vue?vue&type=template&id=67153de6"
import script from "./RuleListStart.vue?vue&type=script&lang=js"
export * from "./RuleListStart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports